module.exports = __webpack_public_path__ + "img/yes.3229b884.png";